<template>
    <div>
        <v-dialog v-model="testAddDialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <test-add-form :filter="filter" @input="onAdd" @cancel="onCancel" @open="testAddDialog = true" :key="formKey" />
        </v-dialog>
        <v-dialog v-model="labSelectionDialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <lab-selection-form :filter="labSelectionFilter" @input="onLabSelected" @cancel="labSelectionDialog = false" @open="labSelectionDialog = true" :key="labSelectionKey" />
        </v-dialog>
        <v-form>
            <v-card>
                <v-card-title>
                    <span class="headline">Sample Tests</span>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="9">
                            Choose which tests you would like to be performed on your sample. B-QUAL will send you an invoice for each test.
                        </v-col>
                        <v-col cols="3">
                            <v-btn color="tertiary" dark class="mr-2 mb-2 float-right" @click="testAddDialog = true">Add Test</v-btn>
                            <v-btn color="tertiary" dark class="mr-2 float-right" @click="labSelectionDialog = true">Download Combined Shipping Label</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table class="elevation-1"
                                          :headers="headers"
                                          :items="items"
                                          :loading="isLoading"
                                          item-key="id"
                                          disable-filtering
                                          disable-pagination
                                          hide-default-footer>
                                <template v-slot:[`item.action`]="{ item }">
                                    <div class="d-flex flex-nowrap justify-end">
                                        <v-icon class="mr-2" @click="onDelete(item)">mdi-delete</v-icon>
                                        <v-btn color="tertiary" dark class="mr-2 float-right" @click="getLabel(item)">Download Shipping Label</v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="quaternary" text @click="$emit('cancel')">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
    import axios from 'axios'
    import errorUtility from '../services/errorUtility'

    export default {
        props: [
            'value',
            'filter',

        ],

        components: {
            testAddForm: () => import("@/forms/TestAddForm"),
            labSelectionForm: () => import("@/forms/LabSelectionForm")
        },

        data() {
            return {
                headers: [
                    { text: "Test", value: "test" },
                    { text: "Lab", value: "lab" },
                    { text: '', value: 'action' }
                ],
                testAddDialog: false,
                formKey: 0,
                items: [],
                labs: [],
                tests: [],
                isLoading: true,
                labSelectionDialog: false,
                labSelectionKey: 0
            }
        },

        methods: {
            async load() {
                var params = {};
                params['filter.sampleId'] = this.value.id;
                var response = await axios.get('/api/SampleTests', { params });
                this.labs = response.data.labs;
                this.tests = response.data.tests;
                this.items = response.data.items;
                this.items = this.items.map(e => {
                    return {
                        id: e.id,
                        test: this.tests[e.testId],
                        lab: this.labs[e.labId],
                        labId: e.labId
                    };
                });
                this.isLoading = false;
            },
            onCancel() {
                this.testAddDialog = false;
                this.formKey++;
            },
            async onAdd(value) {
                this.testAddDialog = false;
                this.formKey++;
                let sampleTest = {
                    sampleId: this.value.id,
                    testId: value.testId,
                    labId: value.labId
                };
                try {
                    await axios.post('/api/SampleTests', sampleTest);
                } catch (error) {
                    errorUtility.handleServerError(error);
                }
                this.load();

            },
            async onDelete(item) {
                if (!confirm('Are you sure you want to delete this sample test?')) {
                    return;
                }
                await axios.delete('/api/SampleTests/' + item.id);
                this.load();
            },
            async getLabel(item) {
                return await axios
                    .get('/api/SampleTests/GetLabelForSampleTest/' + item.id, { responseType: 'blob' })
                    .then(this.saveBlob)
                    .catch((error) => { this.$store.dispatch('alert/error', 'There was an error downloading the file. ' + error) });
            },
            async onLabSelected(labId) {
                var params = {
                    labId,
                    sampleId: this.value.id
                };
                this.labSelectionKey++;
                this.labSelectionDialog = false;
                return await axios
                    .get('/api/SampleTests/GetLabelForLab/', { params, responseType: 'blob' })
                    .then(this.saveBlob)
                    .catch((error) => { this.$store.dispatch('alert/error', 'There was an error downloading the file. ' + error) });
            },
            saveBlob(response) {
                function getFilename(response) {
                    var disposition = response.headers['content-disposition'];

                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);

                        if (matches != null && matches[1]) {
                            return matches[1].replace(/['"]/g, '');
                        }

                        return 'export.pdf';
                    }
                }

                var blob = new Blob([response.data], { type: response.headers['content-type'] });
                var downloadUrl = window.URL.createObjectURL(blob);
                var filename = getFilename(response);
                var link = document.createElement('a');

                if (typeof link.download === 'undefined') {
                    window.location.href = downloadUrl;
                } else {
                    link.href = downloadUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                }
            }
        },

        computed: {
            labSelectionFilter() {
                if (this.items.length === 0) {
                    return null;
                }
                return {
                    ids: this.items.map(e => e.labId)
                };
            }
        },

        watch: {
            value: {
                immediate: true,
                handler() {
                    if (this.value !== null && typeof this.value !== "undefined") {
                        this.load();
                    }
                }
            }
        }
    };
</script>
